import { render, staticRenderFns } from "./SupplierPerformanceWorldMap.vue?vue&type=template&id=7e809d8e&scoped=true"
import script from "./SupplierPerformanceWorldMap.vue?vue&type=script&lang=js"
export * from "./SupplierPerformanceWorldMap.vue?vue&type=script&lang=js"
import style0 from "./SupplierPerformanceWorldMap.vue?vue&type=style&index=0&id=7e809d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e809d8e",
  null
  
)

export default component.exports